import { useState } from "react";

import { Licenses } from "common/components/subscriptions";
import { Button } from "common/components/ui/Button";
import { trackMetaPixel } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function ActivateSubscriptionButton() {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        size={isDesktop ? "sm" : "lg"}
        onClick={() => {
          trackMetaPixel("trackCustom", "FreeTrialApp");
          setIsOpen(true);
        }}
      >
        Activate subscription
      </Button>

      <Licenses isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
}
